import { enums } from '@kattana-io/common';

interface IColorTagProps {
  color: enums.Tag;
  active: boolean;
  onClick(): void;
}

const ColorTag = ({ color, active, onClick }: IColorTagProps) => (
  <div
    className={`color_picker__tag color_picker__tag--${color} ${
      active ? 'color_picker__tag--active' : ''
    }`}
    onClick={active ? undefined : onClick}
  />
);

export default ColorTag;
